import React from 'react';
import { IconProps } from '.';

const SvgHomeOut = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M1.502 10.805 12 1.498l10.497 9.307L22 12.117h-1.75V13h-1.5v-2.383h1.273L12 3.502l-8.023 7.115H5.25V20.75h13.5V20h1.5v2.25H3.75V12.117H2l-.498-1.312Zm18.037 5.308-3.174 3.175-1.06-1.06 1.362-1.364H11.75v-1.5h4.918L15.304 14l1.06-1.06 3.175 3.173Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgHomeOut;
